import { Link, useParams } from 'react-router-dom'
import { useLiveQuery } from 'dexie-react-hooks'
import { banco } from '../../db/banco'
import { buscarVivo } from '../../db/registroVivo'
import EditorPercentuais from './EditorPercentuais'

// Tela propria dos percentuais por produto/linha (revisao de 24/09 da spec).
// Aqui cada percentual continua gravando na hora, item a item -- e a unica
// excecao ao Salvar por aba, porque e uma lista longa editada item por item.
export default function PercentuaisDaRegra() {
  const { id: representadaId, regraId } = useParams()
  const representada = useLiveQuery(async () => (await buscarVivo(banco.representadas, representadaId)) ?? null, [representadaId])
  const regra = useLiveQuery(async () => (await buscarVivo(banco.regras_comissao, regraId)) ?? null, [regraId])
  const tabela = useLiveQuery(
    async () => (regra?.tabela_preco_id ? (await buscarVivo(banco.tabelas_preco, regra.tabela_preco_id)) ?? null : null),
    [regra?.tabela_preco_id],
  )

  if (representada === undefined || regra === undefined || tabela === undefined) {
    return <p className="p-4 text-sm text-slate-500">Carregando…</p>
  }
  if (representada === null || regra === null || regra.tipo !== 'pct_por_item') {
    return (
      <section className="p-4 space-y-3">
        <p className="text-sm text-slate-700">Esta comissão não tem percentuais por produto/linha.</p>
        {/* Task 16 (escolha dela em 25/09, "2", estendida por ela a esta
            tela): volta direto na Politica Comercial. */}
        <Link to={`/representadas/${representadaId}?aba=comercial`} className="text-sm underline text-teal-800">Voltar para a fornecedora</Link>
      </section>
    )
  }
  const deOnde = regra.tabela_preco_id ? `Tabela ${tabela?.nome ?? '(tabela)'}` : 'Comissão padrão da fornecedora'
  return (
    <section className="p-4 space-y-3">
      <div>
        <h2 className="text-lg font-bold text-slate-800">Percentuais por produto/linha</h2>
        <p className="text-sm text-slate-600">{representada.nome} · {deOnde}</p>
      </div>
      <div className="bg-white rounded-xl shadow-sm p-4">
        <EditorPercentuais regra={regra} representadaId={representada.id} />
      </div>
    </section>
  )
}
